import React, {useEffect} from "react"
import CsvDownloader from "react-csv-downloader"
import {BaseButton} from "../components"
import {useStore, useDispatch} from "../Store"
import {getSetListCSV} from "../api"
import {useTranslation} from "react-i18next"
import "../i18n"
import {useCookies} from "react-cookie"
import {getTokenCookie, isAmOne} from "../common"

export default function DownloadEquitySet({group = null, type = null}) {
  const [cookies] = useCookies([])
  const {t} = useTranslation()
  const {
    store: {perspective, mainListCSV, equityCsvState, mainGroup, tabs},
  } = useStore()
  const {dispatch} = useDispatch()

  useEffect(() => {
    const fetch = async () => {
      if (!isAmOne()) return
      const param = {
        group,
        type,
      }
      let index = 2
      if (group === mainGroup[0]) index = 0
      if (group === mainGroup[1]) index = 1
      mainListCSV[index] = await getSetListCSV(getTokenCookie(cookies), param)
      dispatch({
        type: `LOADED_EQUITY_CSV`,
        equityCsvState: true,
      })
    }
    if (!equityCsvState) fetch()
  }, [])

  return (
    <CsvDownloader
      filename={`SimilarChart${group}Equity`}
      suffix
      datas={mainListCSV[perspective]}
      wrapColumnChar={`"`}
      bom={false}
    >
      <BaseButton label={`${group}${t(`downloadEquity`)}`} color="blue" />
    </CsvDownloader>
  )
}
